import { Injectable, inject } from '@angular/core';

import type { TrackingProvider } from '../interfaces/tracking-provider.interface';
import type { TrackingEvent } from '../interfaces/tracking-event.interface';
import { EventBridgeService } from '@core/services/event-bridge/event-bridge.service';
import { PAGINAS_VALIDAS, type OnboardingPagina } from '@core/services/event-bridge/event-bridge.types';

const ACCION_CAMBIO_PAGINA = 'page_view';
const SEPARADOR_TRACKING = /_/g;
const SEPARADOR_CONTRATO = '-';

/**
 * Reexpone como `pagina_cambiada` el evento `page_view` que `TrackingListenerService`
 * ya emite en cada `NavigationEnd`. Se registra como un provider mas del sistema de
 * tracking existente para no duplicar la escucha del router.
 */
@Injectable()
export class PostMessageTrackingProvider implements TrackingProvider {
  public readonly name = 'postMessage';

  private readonly eventBridgeService = inject(EventBridgeService);

  public isAvailable(): boolean {
    return this.eventBridgeService.estaHabilitado();
  }

  public track(event: TrackingEvent): void {
    if (!this.isAvailable() || event.action !== ACCION_CAMBIO_PAGINA) {
      return;
    }

    const pagina = this.resolverPagina(event.section);
    if (!pagina) {
      return;
    }

    this.eventBridgeService.emitir('pagina_cambiada', { pagina });
  }

  /**
   * `listenToRouter()` publica el slug con guiones bajos (`datos_basicos`) y usa `'home'`
   * como fallback cuando no logra resolverlo. El contrato declara guiones y un enum cerrado,
   * asi que se normaliza y se descarta todo lo que no pertenezca a el.
   */
  private resolverPagina(section: string | undefined): OnboardingPagina | null {
    if (!section) {
      return null;
    }

    const candidato = section.replace(SEPARADOR_TRACKING, SEPARADOR_CONTRATO);
    return PAGINAS_VALIDAS.includes(candidato as OnboardingPagina) ? (candidato as OnboardingPagina) : null;
  }
}
